import { Box, styled, Typography } from '@mui/material';

export const InstrumentsContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '100%',
  height: '159px',
  backgroundColor: theme.palette.colors.primaryBackground,
  borderRadius: '12px',
  padding: '16px 0',
}));

export const FiltersContainer = styled(Box)(() => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '16px',
  padding: '0 16px',
}));

export const InstrumentsList = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexDirection: 'row',
  gap: '8px',
  padding: '0 16px',

  msOverflowStyle: 'none',
  scrollbarWidth: 'none',
  '&::-webkit-scrollbar': {
    display: 'none',
  },

  overflowX: 'auto',
  width: 'calc(100vw - 32px)',

  [theme.breakpoints.up('sm')]: {
    width: 'calc(100vw - 64px)',
  },
  [theme.breakpoints.up('md')]: {
    width: 'calc(100vw - 96px)',
  },
}));

export const CardTopInstrumentContainer = styled(Box)(({ theme }) => ({
  display: 'flex',
  flexShrink: 0,
  flexDirection: 'column',
  justifyContent: 'space-between',
  width: '134px',
  height: '97px',
  backgroundColor: theme.palette.colors.secondaryBackground,
  border: `1px solid ${theme.palette.colors.borderLine}`,
  borderRadius: '12px',
  padding: '10px 12px',
}));

export const BoldText = styled(Typography, {
  shouldForwardProp: (prop) => prop !== 'fontSize',
})(({ theme, fontSize }) => ({
  fontSize,
  fontWeight: 'bold',
  lineHeight: 'normal',
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
}));

export const TimeStyled = styled(Typography)(({ theme }) => ({
  fontSize: '10px',
  lineHeight: 1.6,
  letterSpacing: 'normal',
  color: theme.palette.colors.onSecondaryAndDetailBackground,
}));
